const scrollFix = {
  isFixed: false,
  scrollPosition: 0,
  enable() {
    if (!this.isFixed) {
      this.isFixed = true;
      this.scrollPosition = $(window).scrollTop();
      $('.content').css({
        position: 'fixed',
        width: '100%',
        top: `${-this.scrollPosition}px`,
      });
    }
  },
  disable() {
    if (this.isFixed) {
      this.isFixed = false;
      $('.content').css({
        position: '',
        width: '',
        top: '',
      });
      $(window).scrollTop(this.scrollPosition);
    }
  },
};

export default scrollFix;
